var o = /* @__PURE__ */ ((t) => (t.Document = "document", t.Photo = "photo", t))(o || {});
export {
  o as DropzoneTypeEnum
};
